/* eslint-disable */
import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Rate, Avatar } from 'antd';
import { CheckCircleOutlined, ArrowRightOutlined, PlayCircleOutlined, ClockCircleOutlined, DollarOutlined, SafetyCertificateOutlined, ThunderboltOutlined, CarOutlined, UserOutlined, WarningOutlined, HeartOutlined, EnvironmentOutlined, StopOutlined, DownOutlined } from '@ant-design/icons';
import { motion, useInView, useScroll, useTransform } from 'framer-motion';
import { AuthContext, NavBarContext } from '../App';
import bannerImage from '../assets/train.jpg';

// Import avatar images
const avatars = {
  'jamsurfly': require('../assets/avatars/jamsurfly_1615448017.png'),
  'areyousunjae': require('../assets/avatars/areyousunjae_1739685131_7e93c615.jpg'),
  'bumyann': require('../assets/avatars/bumyann_1683032071_46215b65.jpg'),
  'cre008': require('../assets/avatars/cre008_1703059659_8890fc39.jpg'),
  'juneheng04': require('../assets/avatars/juneheng04_1677786419_6db228f3.jpg'),
  'mdshafiz': require('../assets/avatars/mdshafiz_1544794807.jpg'),
  'miko_yixing': require('../assets/avatars/miko_yixing_1491563034.jpg'),
  'missravniac': require('../assets/avatars/missravniac_1425208867.jpg'),
  'peachsofties': require('../assets/avatars/peachsofties_1598151553.jpg'),
  'pizzaman': require('../assets/avatars/pizzaman_1536634410.jpg'),
  'x_littlethings': require('../assets/avatars/x_littlethings_1615901369.jpg'),
  'z.zel': require('../assets/avatars/z.zel_1739285767_a95cf177.jpg'),
  'hotelbooking.com': require('../assets/avatars/hotelbooking.com_1715146094_4889b9a7.jpg'),
  'yenlim33': require('../assets/avatars/yenlim33_1412860754.jpg'),
  'default': require('../assets/avatars/default.png'),
};

const { Title, Paragraph, Text } = Typography;

function Landing() {
  const navigate = useNavigate();
  const { toggleNavBarVisibility } = useContext(NavBarContext);
  const { isAuthenticated } = useContext(AuthContext);
  const [animateStats, setAnimateStats] = useState(false);
  const [randomAvatars, setRandomAvatars] = useState([]);

  // Parallax scroll effects
  const { scrollY } = useScroll();
  const parallaxY1 = useTransform(scrollY, [0, 1000], [0, -100]);
  const parallaxY2 = useTransform(scrollY, [0, 1000], [0, -200]);
  const parallaxRotate = useTransform(scrollY, [0, 1000], [0, 360]);
  
  // Fade out background elements as user scrolls
  const backgroundOpacity = useTransform(scrollY, [0, 400, 800], [1, 0.3, 0]);

  // Get random avatars for hero section
  const getRandomAvatars = () => {
    const avatarKeys = Object.keys(avatars).filter(key => key !== 'default');
    const shuffled = avatarKeys.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 5);
  };

  useEffect(() => {
    toggleNavBarVisibility(false);
    
    if (localStorage.getItem('cid')) {
      navigate('/home');
    }

    // Set random avatars on mount and refresh
    setRandomAvatars(getRandomAvatars());

    // Trigger stats animation after component mounts
    setTimeout(() => setAnimateStats(true), 1000);

    // Handle mobile stats visibility
    const handleStatsVisibility = () => {
      const isMobile = window.innerWidth <= 768;
      const originalStats = document.querySelector('.stats-container');
      const mobileStats = document.querySelector('.mobile-stats-container');
      
      if (originalStats && mobileStats) {
        if (isMobile) {
          originalStats.style.display = 'none';
          mobileStats.style.display = 'block';
        } else {
          originalStats.style.display = 'grid';
          mobileStats.style.display = 'none';
        }
      }
    };

    // Run on load and resize
    setTimeout(handleStatsVisibility, 100); // Delay to ensure DOM is ready
    window.addEventListener('resize', handleStatsVisibility);

    return () => {
      toggleNavBarVisibility(true);
      window.removeEventListener('resize', handleStatsVisibility);
    };
  }, [toggleNavBarVisibility]);

  const handleGetStartedClick = () => {
    window.location.href = 'tg://resolve?domain=SteadyShuttleBot';
    window.location.href = 'https://t.me/steadyshuttlebot';
  };

  const testimonials = [
    {
      name: "jamsurfly",
      displayName: "Jam S.",
      text: "my life saver as i am a singaporean who work in jb. and the shuttle always beats the jam. i will be their loyal follower worth every bit of my penny. service always 100% i dont book from KTMB but from them anymore. 👍👍",
      rating: 5,
      role: "Cross-border Worker",
      avatarKey: "jamsurfly"
    },
    {
      name: "areyousunjae",
      displayName: "Jun E.",
      text: "This is a super convenient service for people who like to go JB often! Booking is seamless and easy and the price is super affordable! No longer have to queue for the public bus which is quite a hassle.",
      rating: 5,
      role: "Frequent Traveler",
      avatarKey: "areyousunjae"
    },
    {
      name: "bumyann",
      displayName: "Bumy A.",
      text: "first time using this sort of service so was q unsure at first, but i really recommend! very convenient and easy to book, was able to get the tix on the desired date with ease! had an amazing chat too :)",
      rating: 5,
      role: "First-time User",
      avatarKey: "bumyann"
    },
    {
      name: "cre008",
      displayName: "Cre008",
      text: "It's was smooth sailing all the way! Thank you SteadyShuttle for finding the tics as requested. Amazing work!",
      rating: 5,
      role: "Happy Customer",
      avatarKey: "cre008"
    },
    {
      name: "juneheng04",
      displayName: "Jun H.",
      text: "been going to JB a few times per week and usually go there by Public transport but it always be crowded and take longer timing to reach especially in peak hour, after using this service, managed to get ticket with a higher success rate even for peak or popular timing",
      rating: 5,
      role: "Daily Commuter",
      avatarKey: "juneheng04"
    },
    {
      name: "mdshafiz",
      displayName: "Md Shafiz",
      text: "highly recommended! i got this to enter jb with my friends, and they came through with the bookings. it was so convenient since i didnt had to so much on my end and hassle-free! when compared to others who are selling the tickets, they're offering it at a cheaper price too!!",
      rating: 5,
      role: "Group Traveler",
      avatarKey: "mdshafiz"
    }
  ];

  const stats = [
    { value: "10,000+", label: "Singaporeans served", icon: <UserOutlined /> },
    { value: "5min", label: "Average journey time", icon: <ClockCircleOutlined /> },
    { value: "93%", label: "Success rate", icon: <SafetyCertificateOutlined /> },
    { value: "24/7", label: "Automated monitoring", icon: <ThunderboltOutlined /> }
  ];

  const problemComparisons = [
    {
      problem: "Record 3+ hour waits, even with QR codes",
      solution: "5-minute express train journey",
      problemIcon: "🚗",
      solutionIcon: "⚡"
    },
    {
      problem: "Packed buses with 45min-2hr wait times",
      solution: "Comfortable seats, max 320 passengers",
      problemIcon: "🚌",
      solutionIcon: "🚄"
    },
    {
      problem: "Long immigration queues with crowds",
      solution: "Dedicated passenger lanes, faster processing",
      problemIcon: "😤",
      solutionIcon: "✅"
    },
    {
      problem: "Train tickets always 'sold out'",
      solution: "AI monitors 24/7, secures when available",
      problemIcon: "❌",
      solutionIcon: "🤖"
    }
  ];

  return (
    <div style={styles.container}>
      {/* Animated Background Elements with Parallax */}
      <motion.div 
        style={{
          ...styles.backgroundElements,
          opacity: backgroundOpacity
        }}
      >
        <motion.div 
          className="floating-background-element"
          style={{
            ...styles.floatingElement, 
            ...styles.element1,
            y: parallaxY1
          }}
          animate={{
            background: [
              'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
              'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            ]
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        ></motion.div>
        <motion.div 
          className="floating-background-element"
          style={{
            ...styles.floatingElement, 
            ...styles.element2,
            y: parallaxY2
          }}
          animate={{
            scale: [1, 1.05, 1],
            opacity: [0.4, 0.5, 0.4]
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        ></motion.div>
        <motion.div 
          className="floating-background-element"
          style={{
            ...styles.floatingElement, 
            ...styles.element3,
            y: parallaxY1
          }}
          animate={{
            scale: [0.9, 1, 0.9],
            opacity: [0.3, 0.4, 0.3]
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        ></motion.div>
        
        {/* Floating Particles - Reduced for mobile performance */}
        {[...Array(window.innerWidth > 768 ? 12 : 6)].map((_, i) => (
          <motion.div
            key={i}
            style={{
              position: 'absolute',
              width: window.innerWidth > 768 ? '6px' : '4px',
              height: window.innerWidth > 768 ? '6px' : '4px',
              background: `linear-gradient(135deg, ${['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'][i % 5]}, white)`,
              borderRadius: '50%',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              zIndex: 1
            }}
            animate={window.innerWidth > 768 ? {
              y: [-20, 20, -20],
              x: [-10, 10, -10],
              scale: [0.5, 1.2, 0.5],
              opacity: [0.3, 0.8, 0.3]
            } : {
              y: [-10, 10, -10],
              opacity: [0.4, 0.7, 0.4]
            }}
            transition={{
              duration: window.innerWidth > 768 ? 3 + Math.random() * 2 : 4,
              repeat: Infinity,
              delay: Math.random() * 2,
              ease: "easeInOut"
            }}
          />
        ))}
      </motion.div>


      {/* Hero Section */}
      <section style={styles.hero}>
        <div style={styles.heroPattern}></div>
        <div style={styles.heroContent} className="hero-content">
          <div style={styles.heroTextContainer}>
            <motion.div 
              style={styles.badge}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <span style={styles.badgeIcon}>⚡</span>
              <span>10,000+ Singaporeans Trust Us</span>
            </motion.div>
            
            <motion.h1 
              style={styles.heroTitle}
              className="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            >
              Skip the Record 3-Hour Wait.
              <br />
              <span style={styles.heroTitleGradient}>Take the 5-Minute Train.</span>
            </motion.h1>
            
            <motion.p 
              style={styles.heroSubtitle}
              className="hero-subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
            >
              While 555,000+ get stuck in record-breaking queues, you'll be enjoying laksa in JB. 
              Our AI-powered system secures KTM train tickets even when "sold out" – guaranteed.
            </motion.p>

            <div style={styles.heroActions}>
              <motion.button 
                style={styles.primaryButton} 
                onClick={handleGetStartedClick}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ 
                  opacity: 1, 
                  scale: 1,
                  boxShadow: [
                    '0 5px 20px rgba(59, 130, 246, 0.2)',
                    '0 10px 30px rgba(59, 130, 246, 0.4)',
                    '0 5px 20px rgba(59, 130, 246, 0.2)'
                  ]
                }}
                transition={{
                  opacity: { duration: 0.6, delay: 0.6 },
                  scale: { duration: 0.6, delay: 0.6 },
                  boxShadow: {
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 1.2
                  }
                }}
                whileHover={{ 
                  scale: 1.05,
                  boxShadow: '0 15px 40px rgba(59, 130, 246, 0.4)',
                  transition: { duration: 0.2 }
                }}
                whileTap={{ scale: 0.95 }}
              >
                <motion.span
                  animate={{ 
                    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "linear"
                  }}
                  style={{
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                    backgroundSize: '200% 100%',
                    WebkitBackgroundClip: 'text',
                    color: 'inherit'
                  }}
                >
                  Get Train Tickets Now
                </motion.span>
                <motion.div
                  animate={{ x: [0, 3, 0] }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                >
                  <ArrowRightOutlined style={styles.buttonIcon} />
                </motion.div>
              </motion.button>
              
              <div style={styles.socialProof} className="social-proof">
                <div style={styles.avatarGroup}>
                  {randomAvatars.map((avatarKey, i) => (
                    <img 
                      key={i} 
                      src={avatars[avatarKey]} 
                      alt={`User ${i + 1}`}
                      style={{
                        ...styles.avatarImage, 
                        marginLeft: i > 0 ? '-8px' : '0',
                        zIndex: 5 - i
                      }}
                    />
                  ))}
                </div>
                <div style={styles.socialText} className="social-text">
                  <Rate disabled defaultValue={5} style={styles.rating} />
                  <a href="https://www.carousell.sg/u/steadyshuttle/reviews/" target="_blank" rel="noopener noreferrer" style={styles.ratingLink}>
                    <span style={styles.ratingText}>5.0 from 10,000+ users</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div style={styles.heroVisual} className="hero-visual">
            <div style={styles.imageContainer}>
              <img src={bannerImage} alt="KTM Shuttle Train" style={styles.heroImage} />
              <div style={styles.imageOverlay}>
                <motion.div 
                  style={styles.floatingCard}
                  initial={{ opacity: 0, scale: 0.8, y: 20 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 1 }}
                  whileHover={{
                    scale: 1.05,
                    rotate: 2,
                    boxShadow: '0 15px 40px rgba(16, 185, 129, 0.4)',
                    transition: { duration: 0.2 }
                  }}
                  animate={{
                    y: [-5, 5, -5],
                    boxShadow: [
                      '0 8px 25px rgba(16, 185, 129, 0.2)',
                      '0 12px 35px rgba(16, 185, 129, 0.3)',
                      '0 8px 25px rgba(16, 185, 129, 0.2)'
                    ]
                  }}
                  transition={{
                    y: { duration: 3, repeat: Infinity, ease: "easeInOut" },
                    boxShadow: { duration: 2, repeat: Infinity, ease: "easeInOut" }
                  }}
                >
                  <div style={styles.cardContent}>
                    <motion.div
                      animate={{ rotate: [0, 360] }}
                      transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
                    >
                      <ClockCircleOutlined style={styles.cardIcon} />
                    </motion.div>
                    <div>
                      <motion.div 
                        style={styles.cardTitle}
                        animate={{ 
                          color: ['#10b981', '#3b82f6', '#10b981']
                        }}
                        transition={{
                          duration: 2,
                          repeat: Infinity,
                          ease: "easeInOut"
                        }}
                      >
                        5 Minutes
                      </motion.div>
                      <div style={styles.cardSubtitle}>vs 4+ Hours by Car</div>
                      
                      {/* Animated Progress Bar */}
                      <motion.div
                        style={{
                          width: '100%',
                          height: '4px',
                          backgroundColor: 'rgba(16, 185, 129, 0.2)',
                          borderRadius: '2px',
                          marginTop: '8px',
                          overflow: 'hidden'
                        }}
                      >
                        <motion.div
                          style={{
                            height: '100%',
                            background: 'linear-gradient(90deg, #10b981, #3b82f6)',
                            borderRadius: '2px'
                          }}
                          initial={{ width: '0%' }}
                          animate={{ width: '100%' }}
                          transition={{
                            duration: 3,
                            delay: 1.5,
                            ease: "easeOut"
                          }}
                        />
                      </motion.div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>

        {/* Animated Stats */}
        <motion.div 
          style={styles.statsContainer}
          className="stats-container"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {stats.map((stat, index) => (
            <motion.div 
              key={index} 
              style={styles.statItem}
              initial={{ opacity: 0, y: 30, scale: 0.8 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ 
                duration: 0.6, 
                delay: 0.3 + index * 0.15,
                ease: "easeOut"
              }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.1, 
                y: -8,
                boxShadow: '0 20px 60px rgba(59, 130, 246, 0.5)',
                transition: { duration: 0.2 } 
              }}
              whileTap={{ scale: 0.95 }}
              animate={{
                boxShadow: [
                  '0 4px 20px rgba(59, 130, 246, 0.1)',
                  '0 8px 30px rgba(59, 130, 246, 0.3)',
                  '0 4px 20px rgba(59, 130, 246, 0.1)'
                ]
              }}
              transition={{
                boxShadow: {
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut"
                }
              }}
            >
              <motion.div 
                style={styles.statIcon}
                initial={{ rotateY: 180 }}
                whileInView={{ rotateY: 0 }}
                transition={{ duration: 0.6, delay: 0.5 + index * 0.15 }}
                viewport={{ once: true }}
              >
                {stat.icon}
              </motion.div>
              <motion.div 
                style={styles.statValue} className="stat-value"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.7 + index * 0.15 }}
                viewport={{ once: true }}
              >
                {stat.value}
              </motion.div>
              <motion.div 
                style={styles.statLabel} className="stat-label"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.9 + index * 0.15 }}
                viewport={{ once: true }}
              >
                {stat.label}
              </motion.div>
            </motion.div>
          ))}
        </motion.div>

        {/* Mobile Stats Section - Hidden by default, shown on mobile */}
        <div 
          className="mobile-stats-container"
          style={{ display: 'none' }}
        >
          <div className="mobile-stats-card">
            <span className="mobile-stat-icon">👥</span>
            <div className="mobile-stat-content">
              <span className="mobile-stat-value">10,000+</span>
              <span className="mobile-stat-text">Users Served</span>
            </div>
          </div>
          <div className="mobile-stats-card">
            <span className="mobile-stat-icon">⏱️</span>
            <div className="mobile-stat-content">
              <span className="mobile-stat-value">5 min</span>
              <span className="mobile-stat-text">Journey Time</span>
            </div>
          </div>
          <div className="mobile-stats-card">
            <span className="mobile-stat-icon">✅</span>
            <div className="mobile-stat-content">
              <span className="mobile-stat-value">93%</span>
              <span className="mobile-stat-text">Success Rate</span>
            </div>
          </div>
          <div className="mobile-stats-card">
            <span className="mobile-stat-icon">⚡</span>
            <div className="mobile-stat-content">
              <span className="mobile-stat-value">Active</span>
              <span className="mobile-stat-text">24/7 Live</span>
            </div>
          </div>
        </div>

        {/* Scroll Indicators */}
        <motion.div 
          style={styles.scrollIndicators}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 2 }}
        >
          <motion.div
            style={styles.scrollHint}
            animate={{ y: [0, 8, 0] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <span style={styles.scrollText}>See how 10,000+ users escape the jam</span>
            <DownOutlined style={styles.scrollIcon} />
          </motion.div>
        </motion.div>
      </section>

      {/* Problem vs Solution Section */}
      <section style={styles.problemSection} className="problem-section">
        <div style={styles.sectionContent} className="section-content">
          <div style={styles.problemHeader}>
            <h2 style={styles.problemMainTitle}>The Causeway Reality vs SteadyShuttle Solution</h2>
            <p style={styles.problemSubtitle}>
              Record 555,000+ crossed in one day. ICA expects 400,000 daily by 2050. Here's why smart commuters choose the train.
            </p>
          </div>

          <motion.div 
            style={styles.comparisonGrid}
            className="comparison-grid"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true, margin: "-100px" }}
          >
            {problemComparisons.map((comparison, index) => (
              <motion.div 
                key={index} 
                style={styles.comparisonCard}
                className="comparison-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
              >
                <motion.div 
                  style={styles.problemSide}
                  className="problem-side"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: index * 0.2 + 0.1 }}
                  viewport={{ once: true }}
                >
                  <motion.div 
                    style={styles.comparisonIcon}
                    className="comparison-icon"
                    whileHover={{ rotate: 10, scale: 1.2 }}
                    transition={{ duration: 0.2 }}
                  >
                    {comparison.problemIcon}
                  </motion.div>
                  <div style={styles.comparisonText} className="comparison-text">{comparison.problem}</div>
                </motion.div>
                <motion.div 
                  style={styles.vsDivider}
                  className="vs-divider"
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.3, delay: index * 0.2 + 0.3 }}
                  viewport={{ once: true }}
                  animate={{ 
                    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "linear"
                  }}
                >
                  VS
                </motion.div>
                <motion.div 
                  style={styles.solutionSide}
                  className="solution-side"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: index * 0.2 + 0.2 }}
                  viewport={{ once: true }}
                >
                  <motion.div 
                    style={styles.comparisonIcon}
                    className="comparison-icon"
                    whileHover={{ rotate: -10, scale: 1.2 }}
                    transition={{ duration: 0.2 }}
                  >
                    {comparison.solutionIcon}
                  </motion.div>
                  <div style={styles.comparisonText} className="comparison-text">{comparison.solution}</div>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>

          <div style={styles.realityBox}>
            <h3 style={styles.realityTitle}>💡 The Hard Truth About Causeway Travel</h3>
            <motion.div 
              style={styles.realityStats} className="reality-stats"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <motion.div 
                style={styles.realityStat}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <CarOutlined style={styles.realityIcon} />
                <div>
                  <div style={styles.realityNumber}>555,000+</div>
                  <div style={styles.realityLabel}>Record daily crossings in chaos</div>
                </div>
              </motion.div>
              <motion.div 
                style={styles.realityStat}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <ClockCircleOutlined style={styles.realityIcon} />
                <div>
                  <div style={styles.realityNumber}>3+ hours</div>
                  <div style={styles.realityLabel}>Wait times during peak periods</div>
                </div>
              </motion.div>
              <motion.div 
                style={styles.realityStat}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <WarningOutlined style={styles.realityIcon} />
                <div>
                  <div style={styles.realityNumber}>400,000</div>
                  <div style={styles.realityLabel}>Daily crossings expected by 2050</div>
                </div>
              </motion.div>
              <motion.div 
                style={styles.realityStat}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <WarningOutlined style={styles.realityIcon} />
                <div>
                  <div style={styles.realityNumber}>Dangerous</div>
                  <div style={styles.realityLabel}>Walking on vehicle roads</div>
                </div>
              </motion.div>
            </motion.div>
            <motion.p 
              style={styles.realityDescription}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
            >
              Recent Good Friday saw 555,000+ people in a single day – a new record. People stuck for hours 
              "packed shoulder to shoulder" in immigration halls, even having to relieve themselves roadside 
              during endless jams. Your dignity deserves better than Causeway chaos.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Enhanced How It Works */}
      <section style={styles.workflowSection} className="workflow-section">
        <div style={styles.sectionContent} className="section-content">
          <motion.div 
            style={styles.workflowHeader}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <motion.h2 
              style={styles.workflowTitle}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              How SteadyShuttle Works
            </motion.h2>
            <motion.p 
              style={styles.workflowSubtitle}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              From booking to boarding in 6 simple steps
            </motion.p>
          </motion.div>
          
          <motion.div 
            style={styles.workflowSteps}
            className="workflow-steps"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true, margin: "-50px" }}
          >
            <motion.div 
              style={styles.workflowStep}
              initial={{ opacity: 0, y: 50, rotateY: -15 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.03,
                rotateY: 5,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                style={styles.stepNumber}
                className="step-number-circle"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ 
                  duration: 0.5, 
                  delay: 0.3,
                  type: "spring",
                  bounce: 0.6
                }}
                viewport={{ once: true }}
              >
                01
              </motion.div>
              <h3 style={styles.stepTitle} className="step-title">Create Passenger Profile</h3>
              <p style={styles.stepDescription} className="step-description">Register passenger details through our Telegram bot. Provide full name, passport/IC info for ticket booking.</p>
              <div style={styles.stepFeature}>👤 One-time setup per passenger</div>
            </motion.div>
            
            <motion.div 
              style={styles.workflowStep}
              initial={{ opacity: 0, y: 50, rotateY: -15 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.03,
                rotateY: 5,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                style={styles.stepNumber}
                className="step-number-circle"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ 
                  duration: 0.5, 
                  delay: 0.4,
                  type: "spring",
                  bounce: 0.6
                }}
                viewport={{ once: true }}
              >
                02
              </motion.div>
              <h3 style={styles.stepTitle} className="step-title">Create Your Booking</h3>
              <p style={styles.stepDescription}>Select travel date, time preferences, and passenger(s). Our system queues your booking request for processing.</p>
              <div style={styles.stepFeature}>📅 Flexible date & time selection</div>
            </motion.div>
            
            <motion.div 
              style={styles.workflowStep}
              initial={{ opacity: 0, y: 50, rotateY: -15 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.03,
                rotateY: 5,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                style={styles.stepNumber}
                className="step-number-circle"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ 
                  duration: 0.5, 
                  delay: 0.5,
                  type: "spring",
                  bounce: 0.6
                }}
                viewport={{ once: true }}
              >
                03
              </motion.div>
              <h3 style={styles.stepTitle} className="step-title">Wait for Approval</h3>
              <p style={styles.stepDescription}>Receive notification when your booking is approved and tickets are secured. Processing time varies by demand.</p>
              <div style={styles.stepFeature}>🔔 Real-time status updates</div>
            </motion.div>
            
            <motion.div 
              style={styles.workflowStep}
              initial={{ opacity: 0, y: 50, rotateY: -15 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.03,
                rotateY: 5,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                style={styles.stepNumber}
                className="step-number-circle"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ 
                  duration: 0.5, 
                  delay: 0.6,
                  type: "spring",
                  bounce: 0.6
                }}
                viewport={{ once: true }}
              >
                04
              </motion.div>
              <h3 style={styles.stepTitle}>Make PayNow Payment</h3>
              <p style={styles.stepDescription}>Complete secure payment via PayNow when booking is approved. Quick and convenient Singapore payment method.</p>
              <div style={styles.stepFeature}>💳 PayNow instant transfer</div>
            </motion.div>
            
            <motion.div 
              style={styles.workflowStep}
              initial={{ opacity: 0, y: 50, rotateY: -15 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.03,
                rotateY: 5,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                style={styles.stepNumber}
                className="step-number-circle"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ 
                  duration: 0.5, 
                  delay: 0.7,
                  type: "spring",
                  bounce: 0.6
                }}
                viewport={{ once: true }}
              >
                05
              </motion.div>
              <h3 style={styles.stepTitle}>Ticket Search & Confirmation</h3>
              <p style={styles.stepDescription}>We search for your tickets and provide booking confirmation with all travel details via Telegram.</p>
              <div style={styles.stepFeature}>🔍 Automated ticket retrieval</div>
            </motion.div>
            
            <motion.div 
              style={styles.workflowStep}
              initial={{ opacity: 0, y: 50, rotateY: -15 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.03,
                rotateY: 5,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                style={styles.stepNumber}
                className="step-number-circle"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ 
                  duration: 0.5, 
                  delay: 0.8,
                  type: "spring",
                  bounce: 0.6
                }}
                viewport={{ once: true }}
              >
                06
              </motion.div>
              <h3 style={styles.stepTitle}>Scan Passport & Board</h3>
              <p style={styles.stepDescription}>Simply scan your passport at the gate, clear immigration, and enjoy your 5-minute journey to JB Sentral.</p>
              <div style={styles.stepFeature}>📱 Contactless boarding</div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Enhanced Benefits Section */}
      <section style={styles.benefitsSection} className="benefits-section">
        <div style={styles.sectionContent} className="section-content">
          <h2 style={styles.benefitsTitle}>Why 10,000+ Singaporeans Choose SteadyShuttle</h2>
          
          <motion.div 
            style={styles.benefitsGrid}
            className="benefits-grid"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <motion.div 
              style={{...styles.benefitCard, background: 'linear-gradient(135deg, #0070f3 0%, #00d2ff 100%)'}}
              className="benefit-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div style={styles.benefitIcon}>
                <ThunderboltOutlined style={{fontSize: '32px', color: '#fff'}} />
              </div>
              <h3 style={styles.benefitTitle} className="benefit-title">Lightning Fast</h3>
              <p style={styles.benefitDescription}>5-minute train ride vs 3+ hour record waits. While 555,000+ queue, you arrive.</p>
              <div style={styles.benefitStat}>36x faster than current peak times</div>
            </motion.div>

            <motion.div 
              style={{...styles.benefitCard, background: 'linear-gradient(135deg, #7c3aed 0%, #f59e0b 100%)'}}
              className="benefit-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div style={styles.benefitIcon}>
                <SafetyCertificateOutlined style={{fontSize: '32px', color: '#fff'}} />
              </div>
              <h3 style={styles.benefitTitle}>93% Success Rate</h3>
              <p style={styles.benefitDescription}>Our AI secures tickets even during "sold out" periods when human booking fails.</p>
              <div style={styles.benefitStat}>10,000+ successful bookings</div>
            </motion.div>

            <motion.div 
              style={{...styles.benefitCard, background: 'linear-gradient(135deg, #10b981 0%, #3b82f6 100%)'}}
              className="benefit-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div style={styles.benefitIcon}>
                <CheckCircleOutlined style={{fontSize: '32px', color: '#fff'}} />
              </div>
              <h3 style={styles.benefitTitle}>Zero Stress</h3>
              <p style={styles.benefitDescription}>No traffic anxiety, no parking fees, no sweaty queues. Just relax and enjoy the ride.</p>
              <div style={styles.benefitStat}>Stress-free guarantee</div>
            </motion.div>

            <motion.div 
              style={{...styles.benefitCard, background: 'linear-gradient(135deg, #ef4444 0%, #ec4899 100%)'}}
              className="benefit-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div style={styles.benefitIcon}>
                <HeartOutlined style={{fontSize: '32px', color: '#fff'}} />
              </div>
              <h3 style={styles.benefitTitle}>Healthier Choice</h3>
              <p style={styles.benefitDescription}>Avoid breathing toxic exhaust fumes and road rage stress. Trains are 7x safer than driving.</p>
              <div style={styles.benefitStat}>20x fewer fatalities than cars</div>
            </motion.div>

            <motion.div 
              style={{...styles.benefitCard, background: 'linear-gradient(135deg, #059669 0%, #0891b2 100%)'}}
              className="benefit-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div style={styles.benefitIcon}>
                <EnvironmentOutlined style={{fontSize: '32px', color: '#fff'}} />
              </div>
              <h3 style={styles.benefitTitle}>83% Cleaner</h3>
              <p style={styles.benefitDescription}>Trains produce 83% less greenhouse gas emissions than cars. Save the planet, one trip at a time.</p>
              <div style={styles.benefitStat}>72% lower carbon footprint</div>
            </motion.div>

            <motion.div 
              style={{...styles.benefitCard, background: 'linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)'}}
              className="benefit-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div style={styles.benefitIcon}>
                <DollarOutlined style={{fontSize: '32px', color: '#fff'}} />
              </div>
              <h3 style={styles.benefitTitle}>Guaranteed Comfort</h3>
              <p style={styles.benefitDescription}>Air conditioning, guaranteed seat, no middle seats. Move around freely without seatbelts.</p>
              <div style={styles.benefitStat}>320 comfortable seats per train</div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      <section style={styles.testimonialsSection} className="testimonials-section">
        <div style={styles.sectionContent} className="section-content">
          <motion.div 
            style={styles.testimonialsHeader}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <motion.h2 
              style={styles.testimonialsTitle}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              Real Stories from Real Users
            </motion.h2>
            <motion.p 
              style={styles.testimonialsSubtitle}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <a href="https://www.carousell.sg/u/steadyshuttle/reviews/" target="_blank" rel="noopener noreferrer" style={styles.testimonialsLink}>
                See all reviews on Carousell →
              </a>
            </motion.p>
          </motion.div>
          
          <motion.div 
            style={styles.testimonialsGrid}
            className="testimonials-grid"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            {testimonials.map((testimonial, index) => (
              <motion.div 
                key={index} 
                style={styles.testimonialCard}
                className="testimonial-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5, transition: { duration: 0.2 } }}
              >
                <div style={styles.testimonialContent}>
                  <Rate disabled defaultValue={testimonial.rating} style={styles.testimonialRating} />
                  <p style={styles.testimonialText}>"{testimonial.text}"</p>
                </div>
                <div style={styles.testimonialAuthor}>
                  <img 
                    src={avatars[testimonial.avatarKey] || avatars.default} 
                    alt={testimonial.displayName}
                    style={styles.testimonialAvatarImage}
                  />
                  <div style={styles.testimonialInfo}>
                    <div style={styles.testimonialName}>{testimonial.displayName}</div>
                    <div style={styles.testimonialRole}>{testimonial.role}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Enhanced CTA Section */}
      <section style={styles.ctaSection} className="cta-section">
        <motion.div 
          style={styles.ctaBackground}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        ></motion.div>
        <motion.div 
          style={styles.ctaGlowEffect}
          initial={{ scale: 0.5, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.2 }}
          viewport={{ once: true }}
        ></motion.div>
        <motion.div 
          style={styles.ctaContent}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <motion.h2 
            style={styles.ctaTitle}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Skip the Chaos.<br />Take the Train.
          </motion.h2>
          <motion.p 
            style={styles.ctaSubtitle}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            While Causeway traffic breaks new records every month, 10,000+ smart Singaporeans 
            have already discovered the 5-minute solution. Join them before it gets worse.
          </motion.p>
          <motion.button 
            style={styles.ctaButton} 
            onClick={handleGetStartedClick}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            whileTap={{ scale: 0.95 }}
          >
            Start Using SteadyShuttle
            <ArrowRightOutlined style={styles.buttonIcon} />
          </motion.button>
          <motion.div 
            style={styles.ctaFeatures}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
            viewport={{ once: true }}
          >
            <motion.span
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 1 }}
              viewport={{ once: true }}
            >
              ⚡ Instant setup
            </motion.span>
            <motion.span
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 1.1 }}
              viewport={{ once: true }}
            >
              🤖 AI-powered booking
            </motion.span>
            <motion.span
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 1.2 }}
              viewport={{ once: true }}
            >
              💯 93% success rate
            </motion.span>
          </motion.div>
          <motion.p 
            style={styles.ctaNote}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 1.4 }}
            viewport={{ once: true }}
          >
            No installation required • Works via Telegram • Instant notifications
          </motion.p>
        </motion.div>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <motion.div 
          style={styles.footerContent}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div style={styles.footerMain} className="footer-main">
            <div style={styles.footerBrand}>
              <h3 style={styles.footerLogo}>SteadyShuttle</h3>
              <p style={styles.footerTagline}>Skip the jam, take the train.</p>
              <p style={styles.footerDescription}>
                AI-powered KTM train ticket booking for 10,000+ smart Singaporeans who refuse to waste hours in Causeway traffic.
              </p>
            </div>
            
            <div style={styles.footerLinks}>
              <div style={styles.footerColumn}>
                <h4 style={styles.footerColumnTitle}>Quick Links</h4>
                <ul style={styles.footerList}>
                  <li><a href="https://t.me/steadyshuttlebot" style={styles.footerLink}>Start Booking</a></li>
                  <li><a href="https://www.carousell.sg/u/steadyshuttle/reviews/" style={styles.footerLink}>Reviews</a></li>
                </ul>
              </div>
              
              <div style={styles.footerColumn}>
                <h4 style={styles.footerColumnTitle}>Support</h4>
                <ul style={styles.footerList}>
                  <li><a href="https://t.me/steadyshuttlebot" style={styles.footerLink}>Telegram Bot</a></li>
                  <li><a href="https://t.me/steadyshuttlesupport" style={styles.footerLink}>Contact Us</a></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div style={styles.footerBottom} className="footer-bottom">
            <div style={styles.footerStats} className="footer-stats">
              <span style={styles.footerStat}>
                <CheckCircleOutlined style={styles.footerStatIcon} />
                10,000+ Users
              </span>
              <span style={styles.footerStat}>
                <ThunderboltOutlined style={styles.footerStatIcon} />
                93% Success Rate
              </span>
              <span style={styles.footerStat}>
                <ClockCircleOutlined style={styles.footerStatIcon} />
                5-Minute Journey
              </span>
            </div>
            
            <div style={styles.footerCopyright} className="footer-copyright">
              <p>© 2024 SteadyShuttle. Making cross-border travel effortless.</p>
              <p style={styles.footerNote}>
                Not affiliated with KTM or ICA. Independent booking service.
              </p>
            </div>
          </div>
        </motion.div>
      </footer>
    </div>
  );
}

export default Landing;

const styles = {
  container: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    background: 'linear-gradient(180deg, #fafafa 0%, #f0f9ff 30%, #fef7ff 70%, #fafafa 100%)',
    color: '#000',
    lineHeight: 1.6,
    position: 'relative',
    overflow: 'hidden',
  },

  // Animated Background Elements
  backgroundElements: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 0,
  },
  floatingElement: {
    position: 'absolute',
    background: 'linear-gradient(135deg, rgba(0, 112, 243, 0.15), rgba(124, 58, 237, 0.15), rgba(16, 185, 129, 0.15))',
    borderRadius: '50%',
    animation: 'float 6s ease-in-out infinite',
    filter: 'blur(1px)',
  },
  element1: {
    width: '300px',
    height: '300px',
    top: '10%',
    left: '80%',
    animationDelay: '0s',
  },
  element2: {
    width: '200px',
    height: '200px',
    top: '60%',
    left: '10%',
    animationDelay: '2s',
  },
  element3: {
    width: '150px',
    height: '150px',
    top: '80%',
    right: '20%',
    animationDelay: '4s',
  },

  // Hero Section
  hero: {
    position: 'relative',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '120px 24px 40px',
    zIndex: 1,
  },
  heroPattern: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    height: '100%',
    background: 'radial-gradient(circle at 25% 25%, rgba(0, 112, 243, 0.05) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(124, 58, 237, 0.05) 0%, transparent 50%)',
    pointerEvents: 'none',
  },
  heroContent: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '80px',
    alignItems: 'center',
    marginBottom: '40px',
  },
  heroTextContainer: {
    maxWidth: '600px',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 20px',
    background: 'linear-gradient(135deg, #000 0%, #333 100%)',
    color: '#fff',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '32px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  },
  badgeIcon: {
    fontSize: '12px',
    animation: 'pulse 2s infinite',
  },
  heroTitle: {
    fontSize: '76px',
    fontWeight: '900',
    lineHeight: '0.9',
    margin: '0 0 32px 0',
    letterSpacing: '-0.04em',
  },
  heroTitleGradient: {
    background: 'linear-gradient(135deg, #0070f3 0%, #7c3aed 50%, #f59e0b 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    animation: 'gradientShift 3s ease-in-out infinite',
  },
  heroSubtitle: {
    fontSize: '22px',
    color: '#666',
    margin: '0 0 48px 0',
    lineHeight: 1.6,
    fontWeight: '400',
  },
  heroActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  },
  primaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px',
    padding: '20px 40px',
    background: 'linear-gradient(135deg, #0070f3 0%, #0060d9 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '16px',
    fontSize: '18px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    alignSelf: 'flex-start',
    boxShadow: '0 8px 25px rgba(0, 112, 243, 0.3)',
    transform: 'translateY(0)',
  },
  buttonIcon: {
    fontSize: '16px',
    transition: 'transform 0.3s ease',
  },
  socialProof: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  avatarGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  avatarImage: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: '3px solid #fafafa',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    objectFit: 'cover',
    position: 'relative',
  },
  socialText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  rating: {
    fontSize: '16px',
  },
  ratingText: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500',
  },
  ratingLink: {
    textDecoration: 'none',
    color: 'inherit',
    transition: 'color 0.2s ease',
  },

  // Hero Visual Enhanced
  heroVisual: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  imageContainer: {
    position: 'relative',
    borderRadius: '32px',
    overflow: 'hidden',
    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    padding: '32px',
    boxShadow: '0 25px 60px rgba(0, 0, 0, 0.12)',
  },
  heroImage: {
    width: '100%',
    maxWidth: '500px',
    height: 'auto',
    borderRadius: '20px',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
  },
  imageOverlay: {
    position: 'absolute',
    top: '20px',
    right: '20px',
  },
  floatingCard: {
    background: 'rgba(0, 0, 0, 0.9)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    padding: '16px 20px',
    color: '#fff',
    animation: 'floatCard 3s ease-in-out infinite',
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  cardIcon: {
    fontSize: '24px',
    color: '#0070f3',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0,
  },
  cardSubtitle: {
    fontSize: '12px',
    color: '#999',
    margin: 0,
  },

  // Enhanced Stats
  statsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '32px',
    padding: '0 0 32px 0',
    borderBottom: '1px solid #e5e5e5',
  },
  statItem: {
    textAlign: 'center',
    padding: '24px',
    borderRadius: '20px',
    background: 'linear-gradient(135deg, #fff 0%, #f8fafc 100%)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
  },
  statIcon: {
    fontSize: '28px',
    color: '#0070f3',
    marginBottom: '16px',
  },
  statValue: {
    fontSize: '36px',
    fontWeight: '900',
    color: '#000',
    marginBottom: '8px',
  },
  statLabel: {
    fontSize: '14px',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    fontWeight: '600',
  },

  // Enhanced Problem Section
  problemSection: {
    backgroundColor: '#fff',
    padding: '120px 24px',
    position: 'relative',
    zIndex: 1,
  },
  sectionContent: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  problemHeader: {
    textAlign: 'center',
    marginBottom: '80px',
  },
  problemMainTitle: {
    fontSize: '48px',
    fontWeight: '800',
    marginBottom: '20px',
    background: 'linear-gradient(135deg, #000 0%, #666 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  problemSubtitle: {
    fontSize: '20px',
    color: '#666',
    maxWidth: '600px',
    margin: '0 auto',
  },
  comparisonGrid: {
    display: 'grid',
    gap: '24px',
    marginBottom: '60px',
  },
  comparisonCard: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    gap: '32px',
    alignItems: 'center',
    padding: '32px',
    background: 'linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)',
    borderRadius: '24px',
    border: '1px solid #e5e5e5',
  },
  problemSide: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '20px',
    backgroundColor: '#fff3f3',
    borderRadius: '16px',
    border: '2px solid #fee',
  },
  solutionSide: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '20px',
    backgroundColor: '#f0fdf4',
    borderRadius: '16px',
    border: '2px solid #dcfce7',
  },
  vsDivider: {
    fontSize: '18px',
    fontWeight: '800',
    color: '#0070f3',
    padding: '12px 20px',
    backgroundColor: '#e6f7ff',
    borderRadius: '12px',
    border: '2px solid #bae7ff',
  },
  comparisonIcon: {
    fontSize: '24px',
    minWidth: '32px',
  },
  comparisonText: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
  },
  realityBox: {
    background: 'linear-gradient(135deg, #0070f3 0%, #7c3aed 100%)',
    borderRadius: '24px',
    padding: '48px',
    color: '#fff',
    textAlign: 'center',
  },
  realityTitle: {
    fontSize: '28px',
    fontWeight: '700',
    marginBottom: '40px',
    color: '#fff',
  },
  realityStats: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '32px',
    maxWidth: '600px',
    margin: '0 auto',
  },
  realityStat: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  realityIcon: {
    fontSize: '32px',
    color: '#fff',
  },
  realityNumber: {
    fontSize: '36px',
    fontWeight: '900',
    color: '#fff',
  },
  realityLabel: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.8)',
    textAlign: 'center',
  },
  realityDescription: {
    fontSize: '18px',
    lineHeight: '1.6',
    color: 'rgba(255, 255, 255, 0.9)',
    marginTop: '32px',
    textAlign: 'center',
  },

  // Enhanced Workflow Section
  workflowSection: {
    backgroundColor: '#fafafa',
    padding: '80px 24px',
    position: 'relative',
    zIndex: 1,
  },
  workflowHeader: {
    textAlign: 'center',
    marginBottom: '80px',
  },
  workflowTitle: {
    fontSize: '48px',
    fontWeight: '800',
    marginBottom: '16px',
    color: '#000',
  },
  workflowSubtitle: {
    fontSize: '20px',
    color: '#666',
  },
  workflowSteps: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '40px',
    alignItems: 'start',
    maxWidth: '1400px',
    margin: '0 auto',
  },
  workflowStep: {
    textAlign: 'center',
    padding: '40px 24px',
    background: '#fff',
    borderRadius: '24px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  stepNumber: {
    width: '72px',
    height: '72px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #0070f3 0%, #7c3aed 100%)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: '800',
    margin: '0 auto 24px',
    boxShadow: '0 8px 25px rgba(0, 112, 243, 0.3)',
  },
  stepTitle: {
    fontSize: '24px',
    fontWeight: '700',
    marginBottom: '16px',
    color: '#000',
  },
  stepDescription: {
    fontSize: '16px',
    color: '#666',
    lineHeight: 1.6,
    marginBottom: '16px',
  },
  stepFeature: {
    fontSize: '14px',
    color: '#0070f3',
    fontWeight: '600',
    backgroundColor: '#e6f7ff',
    padding: '8px 16px',
    borderRadius: '20px',
    display: 'inline-block',
  },
  workflowConnector: {
    width: '2px',
    height: '80px',
    background: 'linear-gradient(180deg, #0070f3 0%, #7c3aed 100%)',
    justifySelf: 'center',
    marginTop: '40px',
  },

  // Benefits Section
  benefitsSection: {
    backgroundColor: '#fff',
    padding: '120px 24px',
    position: 'relative',
    zIndex: 1,
  },
  benefitsTitle: {
    fontSize: '48px',
    fontWeight: '800',
    textAlign: 'center',
    marginBottom: '80px',
    color: '#000',
  },
  benefitsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  benefitCard: {
    padding: '40px 32px',
    background: 'linear-gradient(135deg, #0070f3 0%, #7c3aed 100%)',
    borderRadius: '24px',
    color: '#fff',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    transition: 'transform 0.3s ease',
  },
  benefitIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
  },
  benefitTitle: {
    fontSize: '24px',
    fontWeight: '700',
    marginBottom: '16px',
    color: '#fff',
  },
  benefitDescription: {
    fontSize: '16px',
    lineHeight: 1.6,
    marginBottom: '20px',
    color: 'rgba(255, 255, 255, 0.9)',
  },
  benefitStat: {
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    padding: '8px 16px',
    borderRadius: '20px',
    display: 'inline-block',
  },

  // Enhanced Testimonials
  testimonialsSection: {
    backgroundColor: '#fafafa',
    padding: '120px 24px',
    position: 'relative',
    zIndex: 1,
  },
  testimonialsHeader: {
    textAlign: 'center',
    marginBottom: '80px',
  },
  testimonialsTitle: {
    fontSize: '48px',
    fontWeight: '800',
    marginBottom: '16px',
    color: '#000',
  },
  testimonialsSubtitle: {
    fontSize: '18px',
    color: '#666',
  },
  testimonialsLink: {
    color: '#0070f3',
    textDecoration: 'none',
    fontSize: '18px',
    fontWeight: '600',
    transition: 'color 0.2s ease',
  },
  testimonialsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '32px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  testimonialCard: {
    padding: '32px',
    backgroundColor: '#fff',
    borderRadius: '24px',
    border: '1px solid #f0f0f0',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  testimonialContent: {
    marginBottom: '24px',
  },
  testimonialRating: {
    fontSize: '16px',
    marginBottom: '16px',
  },
  testimonialText: {
    fontSize: '18px',
    color: '#333',
    lineHeight: 1.6,
    margin: 0,
    fontStyle: 'italic',
  },
  testimonialAuthor: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  testimonialAvatarImage: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid #f0f0f0',
  },
  testimonialInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  testimonialName: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#000',
  },
  testimonialRole: {
    fontSize: '14px',
    color: '#666',
  },

  // Enhanced CTA Section
  ctaSection: {
    position: 'relative',
    backgroundColor: '#000',
    color: '#fff',
    padding: '120px 24px',
    textAlign: 'center',
    overflow: 'hidden',
  },
  ctaBackground: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    background: 'radial-gradient(circle at 30% 70%, #0070f3 0%, transparent 50%), radial-gradient(circle at 70% 30%, #7c3aed 0%, transparent 50%)',
    opacity: 0.15,
  },
  ctaGlowEffect: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    height: '600px',
    background: 'radial-gradient(circle, rgba(0, 112, 243, 0.3) 0%, transparent 70%)',
    animation: 'glow 4s ease-in-out infinite',
  },
  ctaContent: {
    position: 'relative',
    maxWidth: '700px',
    margin: '0 auto',
    zIndex: 1,
  },
  ctaTitle: {
    fontSize: '56px',
    fontWeight: '900',
    marginBottom: '24px',
    lineHeight: 1.1,
  },
  ctaSubtitle: {
    fontSize: '22px',
    color: '#ccc',
    marginBottom: '48px',
    lineHeight: 1.5,
  },
  ctaButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '16px',
    padding: '24px 48px',
    background: 'linear-gradient(135deg, #fff 0%, #f0f0f0 100%)',
    color: '#000',
    border: 'none',
    borderRadius: '16px',
    fontSize: '20px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginBottom: '32px',
    boxShadow: '0 8px 30px rgba(255, 255, 255, 0.2)',
  },
  ctaFeatures: {
    display: 'flex',
    justifyContent: 'center',
    gap: '32px',
    marginBottom: '24px',
    fontSize: '16px',
    fontWeight: '600',
  },
  ctaNote: {
    fontSize: '14px',
    color: '#888',
    margin: 0,
  },

  // Scroll Indicators
  scrollIndicators: {
    textAlign: 'center',
    marginTop: '60px',
    marginBottom: '40px',
  },
  scrollHint: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
  },
  scrollText: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500',
  },
  scrollIcon: {
    fontSize: '16px',
    color: '#0070f3',
  },

  // Footer
  footer: {
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    color: '#fff',
    padding: '80px 24px 40px',
    marginTop: '0',
  },
  footerContent: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  footerMain: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '80px',
    marginBottom: '60px',
  },
  footerBrand: {
    maxWidth: '500px',
  },
  footerLogo: {
    fontSize: '32px',
    fontWeight: '800',
    margin: '0 0 16px 0',
    background: 'linear-gradient(135deg, #0070f3 0%, #7c3aed 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  footerTagline: {
    fontSize: '18px',
    color: '#0070f3',
    margin: '0 0 20px 0',
    fontWeight: '600',
  },
  footerDescription: {
    fontSize: '16px',
    color: '#ccc',
    lineHeight: 1.6,
    margin: 0,
  },
  footerLinks: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '40px',
  },
  footerColumn: {},
  footerColumnTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: '0 0 20px 0',
    color: '#fff',
  },
  footerList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  footerLink: {
    color: '#ccc',
    textDecoration: 'none',
    fontSize: '16px',
    lineHeight: 2,
    transition: 'color 0.3s ease',
  },
  footerBottom: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '40px',
    alignItems: 'center',
    paddingTop: '40px',
    borderTop: '1px solid #444',
  },
  footerStats: {
    display: 'flex',
    gap: '32px',
  },
  footerStat: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: '#999',
  },
  footerStatIcon: {
    color: '#0070f3',
    fontSize: '16px',
  },
  footerCopyright: {
    textAlign: 'right',
  },
  footerNote: {
    fontSize: '12px',
    color: '#777',
    margin: '8px 0 0 0',
  },
};

// Add CSS animations
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  }
  
  @keyframes floatCard {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
  }
  
  @keyframes gradientShift {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  
  @keyframes glow {
    0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(1); }
    50% { opacity: 0.5; transform: translate(-50%, -50%) scale(1.1); }
  }
  
  .benefit-card:hover {
    transform: translateY(-8px);
  }
  
  .testimonial-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  }
  
  .workflow-step:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  }
  
  .primary-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 35px rgba(0, 112, 243, 0.4);
  }
  
  .primary-button:hover .button-icon {
    transform: translateX(4px);
  }
  
  .cta-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(255, 255, 255, 0.3);
  }

  /* Mobile Responsive Styles */
  @media (max-width: 768px) {
    /* Hero Section Mobile - Complete rewrite */
    .hero-content {
      display: flex !important;
      flex-direction: column !important;
      gap: 40px !important;
      text-align: center !important;
      grid-template-columns: none !important;
    }
    
    .hero-visual {
      order: -1 !important;
      max-width: 100% !important;
    }
    
    .hero-title {
      font-size: 42px !important;
      line-height: 1.1 !important;
      margin-bottom: 20px !important;
    }
    
    .hero-subtitle {
      font-size: 17px !important;
      margin-bottom: 28px !important;
      padding: 0 10px !important;
    }
    
    /* Hero image mobile */
    .hero-content img {
      max-width: 100% !important;
      height: auto !important;
    }
    
    /* Hero actions mobile */
    .hero-content button {
      width: 100% !important;
      max-width: 320px !important;
      padding: 18px 32px !important;
      font-size: 16px !important;
    }

    /* Mobile badge - Compact version */
    .hero-content > div:first-child > div:first-child {
      padding: 6px 16px !important;
      font-size: 12px !important;
      margin-bottom: 20px !important;
      border-radius: 20px !important;
    }

    .hero-content > div:first-child > div:first-child span:last-child {
      font-size: 12px !important;
    }

    /* Hero image container - With margin and rounded corners */
    .hero-visual > div {
      margin: 0 16px !important;
      border-radius: 20px !important;
      background: none !important;
      padding: 0 !important;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
    }

    .hero-visual img {
      border-radius: 20px !important;
      width: 100% !important;
      margin: 0 !important;
      max-width: 100% !important;
    }

    /* Mobile stats container - Constrained and centered */
    .mobile-stats-container {
      width: 100% !important;
      max-width: 380px !important;
      margin: 0 auto !important;
      padding: 20px 16px !important;
      box-sizing: border-box !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 24px !important;
    }
    
    .mobile-stats-card {
      display: flex !important;
      align-items: flex-start !important;
      gap: 16px !important;
      width: 100% !important;
      min-height: 72px !important;
      background: rgba(255, 255, 255, 0.95) !important;
      backdrop-filter: blur(10px) !important;
      border: 1px solid rgba(255, 255, 255, 0.2) !important;
      border-radius: 16px !important;
      padding: 18px !important;
      margin-bottom: 0 !important;
      box-sizing: border-box !important;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04) !important;
      transition: all 0.3s ease !important;
      position: relative !important;
      overflow: hidden !important;
      cursor: pointer !important;
    }
    
    .mobile-stats-card::before {
      content: '' !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 3px !important;
      background: linear-gradient(90deg, #007bff, #00d4ff) !important;
      opacity: 0.8 !important;
      border-radius: 16px 16px 0 0 !important;
    }
    
    .mobile-stats-card:last-child {
      margin-bottom: 0 !important;
    }
    
    .mobile-stat-content {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      gap: 2px !important;
      flex: 1 !important;
      min-width: 0 !important;
      width: 100% !important;
    }
    
    .mobile-stat-icon {
      font-size: 22px !important;
      width: 36px !important;
      height: 36px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: rgba(0, 123, 255, 0.12) !important;
      border-radius: 10px !important;
      flex-shrink: 0 !important;
      border: 1px solid rgba(0, 123, 255, 0.2) !important;
      margin-top: 2px !important;
    }
    
    .mobile-stat-text {
      font-size: 13px !important;
      font-weight: 500 !important;
      color: #6b7280 !important;
      line-height: 1.2 !important;
      letter-spacing: -0.01em !important;
      margin: 0 !important;
      padding: 0 !important;
      text-align: left !important;
      align-self: flex-start !important;
      width: 100% !important;
      display: block !important;
      white-space: normal !important;
      overflow-wrap: break-word !important;
      word-break: keep-all !important;
      hyphens: auto !important;
    }
    
    .mobile-stat-value {
      font-size: 24px !important;
      font-weight: 700 !important;
      color: #1f2937 !important;
      line-height: 1.1 !important;
      letter-spacing: -0.02em !important;
      margin: 0 !important;
      padding: 0 !important;
      text-align: left !important;
      align-self: flex-start !important;
      width: 100% !important;
      display: block !important;
    }

    /* Workflow Steps Mobile - Single column for better readability */
    .workflow-steps {
      grid-template-columns: 1fr !important;
      gap: 20px !important;
      width: 100% !important;
      box-sizing: border-box !important;
      padding: 0 !important;
      margin: 0 !important;
    }
    
    .workflow-step {
      padding: 20px !important;
      box-sizing: border-box !important;
      width: 100% !important;
      min-width: 0 !important;
    }
    
    .step-title {
      font-size: 18px !important;
      margin-bottom: 12px !important;
      line-height: 1.3 !important;
    }
    
    .step-description {
      font-size: 14px !important;
      line-height: 1.4 !important;
      margin-bottom: 10px !important;
    }

    /* Benefits Grid Mobile - Single column for better text readability */
    .benefits-grid {
      grid-template-columns: 1fr !important;
      gap: 20px !important;
      width: 100% !important;
      min-width: 0 !important;
    }
    
    .benefit-card {
      min-width: 0 !important;
      width: 100% !important;
      padding: 20px !important;
    }
    
    .benefit-title {
      font-size: 18px !important;
      margin-bottom: 12px !important;
    }
    
    .benefit-card p {
      font-size: 14px !important;
      line-height: 1.4 !important;
      margin-bottom: 12px !important;
    }

    /* Problem Section Mobile - Single column for full text display */
    .reality-stats {
      grid-template-columns: 1fr !important;
      gap: 20px !important;
    }
    
    .reality-stat {
      padding: 20px !important;
      font-size: 14px !important;
      text-align: center !important;
    }
    
    .reality-stat strong {
      font-size: 16px !important;
    }

    /* Comparison Grid Mobile - Single column with comfortable spacing */
    .comparison-grid {
      grid-template-columns: 1fr !important;
      gap: 16px !important;
      margin: 0 !important;
      margin-top: 40px !important;
      margin-bottom: 50px !important;
      padding: 0 !important;
    }
    
    .comparison-card {
      flex-direction: column !important;
      gap: 12px !important;
      padding: 16px !important;
      border-radius: 12px !important;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
      box-sizing: border-box !important;
      width: 100% !important;
      margin: 0 !important;
    }
    
    .problem-side,
    .solution-side {
      flex-direction: column !important;
      text-align: center !important;
      padding: 12px !important;
      gap: 8px !important;
      border-radius: 8px !important;
    }
    
    .problem-side {
      background: rgba(255, 107, 107, 0.05) !important;
    }
    
    .solution-side {
      background: rgba(82, 196, 26, 0.05) !important;
    }
    
    .vs-divider {
      align-self: center !important;
      margin: 8px 0 !important;
      padding: 6px 12px !important;
      font-size: 12px !important;
      border-radius: 6px !important;
    }
    
    .comparison-text {
      font-size: 14px !important;
      line-height: 1.4 !important;
      text-align: center !important;
    }
    
    .comparison-icon {
      font-size: 22px !important;
    }

    /* Testimonials Mobile - Single column for better quote readability */
    .testimonials-grid {
      grid-template-columns: 1fr !important;
      gap: 20px !important;
      width: 100% !important;
      min-width: 0 !important;
    }
    
    .testimonial-card {
      min-width: 0 !important;
      width: 100% !important;
      padding: 20px !important;
    }
    
    .testimonial-text {
      font-size: 14px !important;
      line-height: 1.5 !important;
      margin-bottom: 12px !important;
    }
    
    .testimonial-author {
      font-size: 13px !important;
    }

    /* Footer Mobile */
    .footer-main {
      grid-template-columns: 1fr !important;
      gap: 40px !important;
      text-align: center;
    }
    
    .footer-bottom {
      grid-template-columns: 1fr !important;
      text-align: center;
      gap: 20px !important;
    }
    
    .footer-stats {
      justify-content: center;
      flex-wrap: wrap;
      gap: 16px !important;
    }

    .footer-copyright {
      text-align: center !important;
    }

    /* Social Proof Mobile - 3 rows */
    .social-proof {
      flex-direction: column !important;
      align-items: center !important;
      gap: 16px !important;
      text-align: center !important;
    }
    
    .social-text {
      flex-direction: column !important;
      align-items: center !important;
      gap: 8px !important;
    }

    /* Text Sizing - Make all text smaller on mobile */
    h1, .hero-title {
      font-size: 36px !important;
    }
    
    h2 {
      font-size: 28px !important;
      line-height: 1.2 !important;
    }
    
    h3 {
      font-size: 20px !important;
      line-height: 1.3 !important;
    }
    
    h4 {
      font-size: 18px !important;
    }
    
    p, .hero-subtitle {
      font-size: 16px !important;
      line-height: 1.5 !important;
    }
    
    /* Specific component text sizing */
    .stat-value {
      font-size: 24px !important;
    }
    
    .stat-label {
      font-size: 14px !important;
    }
    
    .step-title,
    .benefit-title,
    .testimonial-text {
      font-size: 18px !important;
    }
    
    .step-description,
    .benefit-description {
      font-size: 15px !important;
    }
    
    .testimonial-name,
    .footer-title {
      font-size: 16px !important;
    }
    
    .button-text,
    .cta-button {
      font-size: 16px !important;
    }

    /* General Mobile Adjustments - Compact spacing */
    .section-content {
      padding: 0 16px !important;
    }
    
    /* Section headers with proper spacing */
    h2 {
      margin-bottom: 24px !important;
      font-size: 28px !important;
    }
    
    .section-content h2 {
      margin-bottom: 20px !important;
    }
    
    /* Hero content with breathing room */
    .hero-content {
      gap: 32px !important;
    }
    
    /* Section spacing - more compact */
    .problem-header,
    .workflow-header,
    .benefits-header {
      margin-bottom: 16px !important;
    }
    
    /* Workflow section header - remove excess margins */
    .workflow-header h2 {
      margin-bottom: 8px !important;
    }
    
    .workflow-header p {
      margin-bottom: 16px !important;
    }

    .workflow-section,
    .benefits-section,
    .testimonials-section,
    .cta-section {
      padding: 40px 16px !important;
      overflow-x: hidden !important;
    }
    
    .workflow-section .section-content {
      max-width: 100% !important;
      overflow: hidden !important;
    }
    
    /* CTA Section Mobile Sizing */
    .cta-section h2 {
      font-size: 32px !important;
      line-height: 1.2 !important;
      margin-bottom: 16px !important;
    }
    
    .cta-section p {
      font-size: 16px !important;
      margin-bottom: 32px !important;
      line-height: 1.4 !important;
    }
    
    .cta-section button {
      padding: 16px 32px !important;
      font-size: 16px !important;
      gap: 12px !important;
      margin-bottom: 24px !important;
      border-radius: 12px !important;
    }
    
    /* CTA Features Mobile */
    .cta-section > div:last-child {
      flex-direction: column !important;
      gap: 12px !important;
      font-size: 14px !important;
    }
    
    .cta-section > div:last-child span {
      font-size: 14px !important;
    }

    .problem-section {
      padding: 40px 12px !important;
      margin-top: 40px !important;
    }
    
    /* Ensure section content doesn't overflow */
    .section-content {
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    /* Disable complex animations on mobile for performance */
    * {
      animation-duration: 0.3s !important;
    }
    
    .workflow-step {
      transform: none !important;
    }
    
    .benefit-card:hover {
      transform: scale(1.02) !important;
    }
    
    /* Disable step number circle animations on mobile and make smaller */
    .step-number-circle {
      transform: scale(1) !important;
      animation: none !important;
      transition: none !important;
      width: 50px !important;
      height: 50px !important;
      font-size: 18px !important;
    }
    
    /* Hide floating background circles on mobile */
    .floating-background-element {
      display: none !important;
    }
  }

  /* Tablet Styles */
  @media (max-width: 1024px) and (min-width: 769px) {
    .hero-title {
      font-size: 56px !important;
    }
    
    .benefits-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }
    
    .testimonials-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }

  @media (max-width: 480px) {
    /* Extra small mobile screens - Even smaller text */
    .hero-title, h1 {
      font-size: 28px !important;
      margin-bottom: 16px !important;
    }
    
    .hero-subtitle, p {
      font-size: 14px !important;
      padding: 0 5px !important;
    }
    
    h2 {
      font-size: 24px !important;
    }
    
    h3 {
      font-size: 18px !important;
    }
    
    .stat-value {
      font-size: 20px !important;
    }
    
    .stat-label {
      font-size: 12px !important;
    }
    
    .step-title,
    .benefit-title {
      font-size: 16px !important;
    }
    
    .step-description,
    .benefit-description {
      font-size: 13px !important;
    }
    
    .testimonial-text {
      font-size: 14px !important;
    }
    
    .stats-container {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 12px !important;
    }
    
    .stat-value {
      font-size: 20px !important;
    }
    
    .stat-label {
      font-size: 10px !important;
    }
    
    /* Comparison cards for very small screens - single column with smaller text */
    .comparison-grid {
      gap: 12px !important;
      margin-top: 30px !important;
      margin-bottom: 40px !important;
    }
    
    .comparison-card {
      padding: 14px !important;
      gap: 10px !important;
    }
    
    .problem-side,
    .solution-side {
      padding: 10px !important;
      gap: 6px !important;
    }
    
    .comparison-text {
      font-size: 13px !important;
      line-height: 1.3 !important;
    }
    
    .comparison-icon {
      font-size: 20px !important;
    }
    
    .vs-divider {
      padding: 5px 10px !important;
      font-size: 11px !important;
      margin: 6px 0 !important;
    }
    
    .footer-stats {
      flex-direction: column !important;
      align-items: center !important;
      gap: 12px !important;
    }
    
    .hero-content button {
      padding: 16px 24px !important;
      font-size: 15px !important;
    }
    
    /* Reduce section padding on very small screens */
    .workflow-section,
    .benefits-section,
    .testimonials-section,
    .cta-section,
    .problem-section {
      padding: 30px 8px !important;
    }
    
    .problem-section {
      margin-top: 30px !important;
    }
    
    /* CTA Section Very Small Mobile */
    .cta-section h2 {
      font-size: 24px !important;
      line-height: 1.3 !important;
      margin-bottom: 12px !important;
    }
    
    .cta-section p {
      font-size: 14px !important;
      margin-bottom: 24px !important;
    }
    
    .cta-section button {
      padding: 14px 24px !important;
      font-size: 14px !important;
      gap: 8px !important;
      margin-bottom: 20px !important;
    }
    
    /* CTA Features Very Small Mobile */
    .cta-section > div:last-child span {
      font-size: 12px !important;
    }
  }

  /* iPhone SE and similar small screens */
  @media (max-width: 375px) {
    .hero-title, h1 {
      font-size: 24px !important;
    }
    
    .hero-subtitle, p {
      font-size: 13px !important;
    }
    
    h2 {
      font-size: 20px !important;
    }
    
    h3 {
      font-size: 16px !important;
    }
    
    .stat-value {
      font-size: 18px !important;
    }
    
    .stat-label {
      font-size: 11px !important;
    }
    
    .step-title,
    .benefit-title {
      font-size: 15px !important;
    }
    
    .step-description,
    .benefit-description {
      font-size: 12px !important;
    }
    
    .testimonial-text {
      font-size: 13px !important;
    }
    
    .button-text,
    .cta-button {
      font-size: 14px !important;
    }
    
    .section-content {
      padding: 0 8px !important;
    }
  }
`;
document.head.appendChild(styleSheet);